import {Component, ElementRef, HostBinding, HostListener, Input, ViewChild, ViewContainerRef} from '@angular/core';
import {Router} from "@angular/router";
import {hunBody, hunChar} from '../../defines/gukeo.func';
import {LIST_TYPE, SearchParam} from "../../defines/client.const";
import {WordHistoryService} from "../../services/word/word-history.service";
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {DynamicComponentService} from "../../services/dynamic-component/dynamic-component.service";
import {WordListItemComponent} from "../word-list-item/word-list-item.component";


@Component({
  selector: 'app-word-detail-homonym',
  styleUrls: ['./word-detail-homonym.component.scss'],
  template: `
    <ng-container *ngIf="word">

      <!-- #container 의 퀴치는 컴포는트의 가장 상위 첫번째 child 이어야 함 -->
      <ng-container #container></ng-container>

      <div class="meaning-head-box">
        <app-word-disp [word]="word"
                       class="small"></app-word-disp>

        <div *ngIf="word?.wordVoice"
             class="detail-option-box">
          <!-- 소리 재생 버튼 -->
          <app-dialect-word-play-btn [word]="word"></app-dialect-word-play-btn>
        </div>
      </div>

      <div class="meaning-body-box">
        <div class="meaning-word-list">
          <div *ngFor="let poomsa of word?.partOfSpeech"
               class="meaning-pumsa">{{ GetPoomsaTxt(poomsa) }}</div>

          <!-- TODO: homonum.hun 으로 변경해야 함 -->
          <div *ngFor="let hun of word?.hanjaHun"
               class="meaning-word-box">{{ hunBody(hun) }}&nbsp;
            <b>{{ hunChar(hun) }}</b>
          </div>

        </div>
      </div>

      <div class="meaning-foot-box">

        <div class="meaning-label-list">

          <!-- 기본 뜻이 있는 경우 -->
          <div class="label-item-box"
               *ngIf="getDefaultMeaning(word)">

            <div class="label-subject-box">
              <div *ngFor="let poomsa of word?.partOfSpeech"
                   class="label-subject-txt">
                <div class="border-box">뜻</div>
              </div>
            </div>
            <div class="label-con-box">
              <div class="txt-box"
                   [innerHTML]="getDefaultMeaning(word) | resize">
              </div>
            </div>
          </div>

          <!-- 뜻이 여러개인 경우 -->
          <div class="label-item-box"
               *ngFor="let meaning of getNumberedMeanings(word); let idx = index">

            <div class="label-subject-box">
              <div *ngFor="let poomsa of word?.partOfSpeech"
                   class="label-subject-txt">
                <div class="border-box">{{ (!getDefaultMeaning(word) && idx === 0) ? "뜻" : "" }}</div>
              </div>
            </div>

            <div class="label-con-box">
              <div class="txt-box flex">
                <div class="txt-box-num">{{(idx + 1).toString() + '.'}}</div>
                <div class="txt-box-meaning"
                     [innerHTML]="meaning | resize">
                </div>
              </div>
            </div>
          </div>


          <div class="label-item-box"
               *ngIf="getMoreMeanings(word!) > 0">
            <div class="label-con-box">
              <div class="txt-box more"><{{ getMoreMeanings(word!) }}개의 뜻이 더 있습니다.></div>
            </div>
          </div>

        </div>

      </div>

    </ng-container>
  `,
})
export class WordDetailHomonymComponent extends WordListItemComponent {
  /**
   * TODO: MultiLinkMixin 사용하는 부분 코드 제거. 상위의 컴포넌트와 같이 처리 필요.
   *       기획이 변경되어서 더 이상 MultiLinkMixin를 사용하지 않게 됨.
   */
  @ViewChild('container', {read: ViewContainerRef}) container?: ViewContainerRef;
  @HostBinding('class') class = 'meaning-box';
  // @HostBinding('style.display') styleBlock = 'block';

  @Input() fromHomonym = false; // 이운이의어 화면에서 불려졌는지?

  protected readonly hunBody = hunBody;
  protected readonly hunChar = hunChar;

  constructor(
    public override router: Router,
    public override wHistorySvc: WordHistoryService,
    public override dynamicSvc: DynamicComponentService,
    protected override elementRef: ElementRef,
    private globalEventSvc: GlobalEventService,
  ) {
    super(router, wHistorySvc, dynamicSvc, elementRef);
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    console.log('WordDetailHomonymComponent::onClick()');
    event.preventDefault();
    event.stopPropagation();
    this.globalEventSvc.Click(event, true);

    if (!this.word) {
      throw new Error('WordDetailHomonymComponent::onClick() homonym is null');
    }
    if (this.container === undefined) {
      throw new Error('WordDetailHomonymComponent::onClick() container is undefined');
    }

    // this.OpenWordLink(this.word.id, this.container).subscribe();
    if (this.wHistorySvc.getById(this.word.id) === null) {
      // 없으면 추가.
      this.wHistorySvc.addHistory(this.word.id);
    }
    const queryParams: SearchParam = {
      id: this.word.id,
    };
    const commands = this.fromHomonym ? ['/homonym'] : ['/word', LIST_TYPE.SERVER];
    this.router.navigate(commands, {queryParams}).then();
  }

  protected GetMeaningTxt(): string {
    const meanings = this.word?.meaning;
    if (meanings) {
      if (meanings.length > 1) {
        return meanings[0] + ' (추가 ' + (meanings.length - 1) + '개 뜻 존재)';
      } else {
        return meanings[0];
      }
    }
    return meanings ? meanings[0] : '';
  }
}
